<template>
	<div class="main-contents">
		<div class="tit">파트너사 정보관리</div>
		<div class="search-box">
			<SelectComp cdId="PRO105" v-model="srchFilter.indtypeClassCd" :isAll="true" title="산업분야"/>
			<Nbsp/>
			<InputComp v-model="srchFilter.srchTxt" placeholder="파트너사명" @keyup.enter="getSupplyCorpInfoList('1')" />
			<img class="search_btn" src="/images/admin/search_btn.png" alt="검색버튼" @click="getSupplyCorpInfoList('1')"/>
			<div class="sub_btn" @click="$router.push('MEM936M01')">
				+ 파트너사 등록
			</div>
		</div>
		<!-- 전체프로젝트 리스트 -->
		<div class="Board type3">
			<table class="Board_type3 admin">
				<colgroup>
					<col width="5%">
					<col width="30%">
					<col width="12%">
					<col width="20%">
					<col width="10%">
				</colgroup>
				<thead>
					<tr>
						<th>NO</th>
						<th>기업명</th>
						<th>사업자등록번호</th>
						<th>산업분야</th>
						<th>등록일</th>
					</tr>
				</thead>
				<tbody v-if="supCorpList.length > 0">
					<!-- 최대 25건 조회 -->
					<tr v-for="(row, rowIdx) in supCorpList" :key="rowIdx">
						<td class="score">{{(pageInfo.pageIndex - 1) * pageInfo.pageUnit + (rowIdx + 1)}}</td>
						<td class="score name" @click="corpPopup(row.corpSeq)">{{row.corpNm}} &#9654;</td>
						<td class="score">{{row.bizRegNo | bizNo}}</td>
						<td class="score"><SelectComp type="text" cdId="PRO105" v-model="row.indtypeClassCd" /></td>
						<td class="score">{{row.regYmd | date('yyyy.MM.dd')}}</td>
					</tr>
				</tbody>
				<tbody v-else>
					<!-- 관련내용 없을 경우 -->
					<tr>
						<td colspan="5" class="none">등록된 파트너사가 없습니다.</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- 페이징부분 -->
		<pagingComp :pageInfo="pageInfo" @page-click="goPage"/>
	</div>
</template>

<script>
import pagingComp from '@/components/PagingComp.vue';

export default {
	data() {
		return {
			// 검색조건
			srchFilter : {
				indtypeClassCd : '',
				srchTxt : '',
				pageIndex : 1,
			},

			// 클라이언트 목록
			supCorpList : [],

			// 페이징
			pageInfo : {},
		}
	},

	components : {
		pagingComp
	},

	beforeMount() {
		
	},

	mounted() {

		var keys = Object.keys(this.srchFilter);
		for(var key in this.$route.params){
			if(keys.indexOf(key) >= 0){
				this.srchFilter[key] = this.$route.params[key];
			}
		}

		this.getSupplyCorpInfoList()
	},

	methods : {
		// 파트너사 목록 조회
		getSupplyCorpInfoList(div) {
			var param = this.srchFilter;
			param.pageUnit = '25';
			param.pageSize = '10';
			if(div) param.pageIndex = 1;

			//console.log('getSupplyCorpInfoList PARAM ', param);

			this.$.httpPost('/api/mem/adm/sco/getSupplyCorpInfoList', param)
				.then(res => {
					//console.log('getSupplyCorpInfoList RESULT', res);

					this.supCorpList = res.data.supCorpList;
					this.pageInfo = res.data.pageInfo;
				}).catch(this.$.httpErrorCommon);
		},

		// 페이징 이동
		goPage(page) {
			this.srchFilter.pageIndex = page;
			this.getSupplyCorpInfoList();
		},

		corpPopup(seq) {
			var param = {};
			param.div = ' sco';
			param.corpSeq = seq;

			this.$.popup('/adm/mem/MEM921P01', param);
		}


	}
}
</script>